import { RouterModule, Routes } from "@angular/router";

import { LoginComponent } from "./components/login/login.component";
import { InitiatePasswordResetComponent } from "./components/password/initiate-password-reset/initiate-password-reset.component";
import { DashboardComponent } from "./components/dashboard/dashboard.component";
import { FleetReportsComponent } from "./components/reports/fleet-reports/fleet-reports.component";
import { VesselReportsComponent } from "./components/reports/vessel-reports/vessel-reports.component";
import { NotFoundComponent } from "./components/not-found/not-found.component";
import { AuthGuard } from "./guards/auth/auth.guard";
import { LoginGuard } from "./guards/login/login.guard";
import { ChangePasswordComponent } from "@app/components/password/change-password/change-password.component";
import { PasswordResetComponent } from "@app/components/password/password-reset/password-reset.component";
import { HullConditionComponent } from "@app/components/hull-condition/hull-condition.component";
import { MapComponent } from "@app/components/map/map.component";
import { VoyageReportsComponent } from "@app/components/voyages/voyage-reports.component";
import { CiiRatingComponent } from "./components/cii-rating/cii-rating.component";
import { DataStorageComponent } from "./components/data-storage/data-storage/data-storage.component";
import { FleetStatusComponent } from "./components/fleet-status/fleet-status.component";

const routes: Routes = [
  {
    path: "map/:vessel",
    component: MapComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "details/:vessel",
    component: DashboardComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "reports/:vessel",
    component: VesselReportsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "hull/:vessel",
    component: HullConditionComponent,
    canActivate: [AuthGuard],
    data: { permissions: ["fo:hull-condition"] },
  },
  {
    path: "voyagereports/:vessel",
    component: VoyageReportsComponent,
    canActivate: [AuthGuard],
    data: { permissions: ["fo:voyages"] },
  },
  {
    path: "cii/:vessel",
    component: CiiRatingComponent,
    canActivate: [AuthGuard],
    data: { permissions: ["fo:cii"] },
  },
  {
    path: "datastorage/:vessel",
    component: DataStorageComponent,
    canActivate: [AuthGuard],
    data: { permissions: ["fo:storage"] },
  },
  {
    path: "fleetreports",
    component: FleetReportsComponent,
    canActivate: [AuthGuard],
    data: { roles: ["ClientAdmin"] },
  },
  {
    path: "fleetstatus",
    component: FleetStatusComponent,
    canActivate: [AuthGuard],
    data: { roles: ["ClientAdmin", "FleetOnlineAdmin"], permissions: ["fo:fleet-status"] },
  },
  {
    path: "account/password",
    component: ChangePasswordComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "login",
    component: LoginComponent,
    canActivate: [LoginGuard],
  },
  {
    path: "initiate-password-reset",
    component: InitiatePasswordResetComponent,
    canActivate: [LoginGuard],
  },
  {
    path: "password-reset",
    component: PasswordResetComponent,
    canActivate: [LoginGuard],
  },
  {
    path: "map",
    pathMatch: "full",
    redirectTo: "map/",
  },
  {
    path: "details",
    pathMatch: "full",
    redirectTo: "details/",
  },
  {
    path: "reports",
    pathMatch: "full",
    redirectTo: "reports/",
  },
  {
    path: "hull",
    pathMatch: "full",
    redirectTo: "hull/",
  },
  {
    path: "voyagereports",
    pathMatch: "full",
    redirectTo: "voyagereports/",
  },
  {
    path: "cii",
    pathMatch: "full",
    redirectTo: "cii/",
  },
  {
    path: "datastorage",
    pathMatch: "full",
    redirectTo: "datastorage/",
  },
  {
    path: "",
    pathMatch: "full",
    redirectTo: "map/",
  },
  {
    path: "notfound",
    component: NotFoundComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "**",
    component: NotFoundComponent,
    canActivate: [AuthGuard],
  },
];

export const AppRouting = RouterModule.forRoot(routes, {
  useHash: false,
  onSameUrlNavigation: "reload",
});
